// src/components/support/forms/EarlyResume.js
import React, { useState } from "react";
import { ChevronLeft } from "lucide-react";
import SpinnerLoading from "../../common/SpinnerLoading";
import FootprintDatePicker from "../../common/FootprintDatePicker";
import moment from "moment";

import { resumeFromBreak } from "../../../queryfunctions/queryfunctions";
import { useRequestProcessor } from "../../../requestProcessor";
import { SERVER_DATE_FORMAT } from "../../home/Home";
import { selectedSupportItem } from "../../../atomstore/store";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";


const DEFAULT_FORMAT = "MMM DD, YYYY";

const EarlyResume = () => {
    const navigate = useNavigate();
    const [item] = useAtom(selectedSupportItem);

    const [newDate, setNewDate] = useState("");
    const [error, setError] = useState("");

    const { useMutationWrapper } = useRequestProcessor();

    const resumeMutation = useMutationWrapper(
        ["resumeFromBreak"],
        () => resumeFromBreak(item.request_id, newDate)
    );

    const validate = () => {
        if (!newDate) {
            setError("Please select the new date");
            return false;
        }
        return true;
    };

    const submitRequest = () => {
        if (validate()) {
            resumeMutation.mutate();
        }
    };

    if (!item) {
        return (
            <div className="p-4">
                <p className="text-center text-gray-600">Unable to load data</p>
            </div>
        );
    }

    return (
        <div className="fixed inset-0 bg-gray-50 z-50 overflow-y-auto">
            {resumeMutation?.isLoading && <SpinnerLoading />}

            {/* Header */}
            <div className="sticky top-0 bg-white border-b p-4 flex items-center space-x-3">
                <button onClick={() => navigate(-1)}>
                    <ChevronLeft className="w-6 h-6 text-gray-600" />
                </button>
                <h2 className="text-lg font-bold text-gray-800 cursor-pointer" onClick={() => navigate(-1)}>Resume Early</h2>
            </div>

            <div className="p-4 space-y-4">

                {/* Info Box */}
                <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-lg">
                    <p className="text-sm text-blue-800">
                        You are resuming services earlier than planned.
                    </p>
                </div>

                {/* Current End Date */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Current End Date
                    </label>
                    <FootprintDatePicker
                        defaultDate={moment(item?.end_date).format(DEFAULT_FORMAT)}
                        inputProps={{ disabled: true }}
                        disabled={true}
                    />
                </div>

                {/* New Resume Date */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        New Date
                    </label>
                    <FootprintDatePicker
                        minimumDate={moment(item?.date, SERVER_DATE_FORMAT).add(1, "days")}
                        maximumDate={moment(item?.end_date, SERVER_DATE_FORMAT).subtract(1, "days")}
                        onChange={(date) => {
                            setNewDate(date);
                            setError("");
                        }}
                        inputProps={{ placeholder: "Select date" }}
                        timeFormat={false}
                    />
                </div>

                {/* Error */}
                {error && <p className="text-red-500 text-sm">{error}</p>}

                {/* Submit */}
                <button
                    onClick={submitRequest}
                    disabled={resumeMutation.isLoading}
                    className="w-full bg-cyan-500 text-white py-3 rounded-xl font-semibold hover:bg-cyan-600 transition disabled:opacity-60"
                >
                    Submit Request
                </button>
            </div>
        </div>
    );
};

export default EarlyResume;
